import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class FilterHatchService {
    public cleared$: Observable<void>;
    private cleared = new Subject<void>();

    constructor() {
        this.cleared$ = this.cleared.asObservable();
    }

    public clearGridFilter(): void {
        this.cleared.next();
    }
}
